import AccordionComponent from './accordionComponent';
let debouncerId;
export default class AccordionTwoColumnInfoBlock extends AccordionComponent {
    constructor(element) {
        super(element);
        this.initAccordion();
        if (this.$options.openedaccordion) {
            this.checkHeight();
        }
        window.addEventListener('resize', () => {
            clearTimeout(debouncerId);
            debouncerId = window.setTimeout(() => {
                setTimeout(() => this.checkHeight(), 400);
            }, 300);
            // this.checkHeight();
        });
    }
    get CONTROLS() {
        return {
            id: 'aria-controls',
        };
    }
    checkHeight() {
        if (!this.$el.classList.contains('accordion-collapsed')) {
            let sectionPanel = this.$el.querySelector('.accordion__panel');
            sectionPanel.style.height = 'auto';
            let sectionFullHeight = sectionPanel.scrollHeight;
            // console.log(sectionFullHeight);
            sectionPanel.style.height = sectionFullHeight + 'px';
        }
    }
    toggleAccordion(e, el) {
        var _a;
        e.preventDefault();
        let _id = el.getAttribute(this.CONTROLS.id);
        let accordionWrapper = el.closest('.accordion__item');
        let sectionPanel = document.getElementById(_id);
        let sectionFullHeight = sectionPanel.scrollHeight;
        if (el.getAttribute(this.ATTRIBUTES.isExpanded) == 'true') {
            this.$el.classList.add('accordion-collapsed');
            sectionPanel.style.height = 0 + 'px';
            el.setAttribute(this.ATTRIBUTES.isExpanded, 'false');
            setTimeout(() => {
                accordionWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 300);
        }
        else {
            const dataAnalytics = el.getAttribute('data-analytics');
            if (dataAnalytics) {
                (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(JSON.parse(dataAnalytics));
            }
            // this.accordionHeaders.forEach((el) => el.setAttribute(this.ATTRIBUTES.isExpanded, 'false'));
            el.setAttribute(this.ATTRIBUTES.isExpanded, 'true');
            sectionPanel.style.height = sectionFullHeight + 'px';
        }
    }
}
